import { useRef, useState } from 'react';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { Box, Button, Typography } from '@mui/material';
import { useLocalization, Wizard } from '@ui-framework/index';
import {
  ASSIGNED_SP_DISPATCH_METHOD,
  DISPATCH_METHODS,
} from '@constants/index';
import { IconLibrary } from '@product-framework/index';
import PresetCalendar from '../DispatchWizard/views/PresetCalendar';
import { useServiceProvider } from '../../../../providers/ServiceProviderProvider';

function ServiceJobAssignWizard({
  isReAssign = false,
  isAssign = false,
  locationId,
}) {
  const wizardRef = useRef();
  const { serviceProvider } = useServiceProvider();
  const { formatMessage } = useLocalization();

  const [activeStep, setActiveStep] = useState(0);
  let titleStep1 = formatMessage(
    {
      id: 'ASSIGN_JOB_TO_SERVICEPROVIDERNAME',
      defaultMessage: 'Assign job to {serviceProviderName}',
    },
    { serviceProviderName: serviceProvider?.name },
  );
  if (isReAssign) {
    titleStep1 = formatMessage(
      {
        id: 'RESSSIGN_JOB_TO_SERVICEPROVIDERNAME',
        defaultMessage: 'Resssign job to {serviceProviderName}',
      },
      { serviceProviderName: serviceProvider?.name },
    );
  }

  const ASSIGN_STEPS_CONFIG = [
    {
      component: (
        <PresetCalendar
          isReAssign={isReAssign}
          isAssign={isAssign}
          serviceProviderId={serviceProvider?.id}
          locationId={locationId}
        />
      ),
      name: `${ASSIGNED_SP_DISPATCH_METHOD}_${DISPATCH_METHODS.PRESET_CALENDAR_BASED_SCHEDULING}`,
      wizardStepName: serviceProvider?.name,
      wizardTitle: titleStep1,
      icon: <IconLibrary.LiveCalendar />,
    },
    {
      component: <PresetCalendar isReAssign={isReAssign} isAssign={isAssign} />,
      name: DISPATCH_METHODS.PRESET_CALENDAR_BASED_SCHEDULING,
      wizardStepName: 'Use Calendar Scheduling',
      wizardTitle: 'Calendar Scheduling',
      icon: <IconLibrary.LiveCalendar />,
    },
  ];

  const steps = ASSIGN_STEPS_CONFIG;

  const isFirst = activeStep === 0;
  const isLast = activeStep === steps.length - 1;

  const onStepChange = step => {
    setActiveStep(step);
  };

  return (
    <Box>
      {Array.isArray(steps) && steps.length > 1 && (
        <Box>
          <Grid2 container>
            <Grid2 xs={4}>&nbsp;</Grid2>
            <Grid2 xs={4}>
              <Typography variant="h6" color="primary">
                {steps[activeStep].wizardTitle}
              </Typography>
            </Grid2>
            <Grid2 xs={4} sx={{ textAlign: 'right' }}>
              {!isFirst && (
                <Button
                  variant="outlined"
                  endIcon={steps[activeStep - 1].icon}
                  onClick={() => wizardRef?.current?.previous()}>
                  {steps[activeStep - 1].wizardStepName}{' '}
                </Button>
              )}
              {!isLast && (
                <Button
                  variant="outlined"
                  onClick={() => wizardRef?.current?.next()}
                  startIcon={steps[activeStep + 1].icon}>
                  {steps[activeStep + 1].wizardStepName}
                </Button>
              )}
            </Grid2>
          </Grid2>
        </Box>
      )}
      <Wizard
        ref={wizardRef}
        activeStep={activeStep}
        onStepChange={onStepChange}
        steps={steps}
      />
    </Box>
  );
}

export default ServiceJobAssignWizard;
